<template>
    <nav class="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-p-3 tw-shadow-md bg-white">
        <div class="tw-flex tw-items-center tw-flex-shrink-0 tw-text-white tw-mr-6">
            <span class="tw-ml-10 tw-font-semibold tw-text-xl tw-tracking-tight">
                <router-link to="/" class="text-white">
                    <img src="../assets/logo.svg" class="tw-h-16" alt="logo" >
                </router-link>
            </span>
        </div>
    </nav>
</template>

<script>
export default {
    name: "LoginHeader"
}
</script>